import { App, Directive } from "vue";

/**
 * DatePickerScroll プラグイン
 *
 * Vuetify 3 の v-date-picker 上でマウスホイールを回転させた際に、
 * 表示月を前後に移動させるカスタムディレクティブ v-datepicker-scroll を提供する。
 * ページ全体のスクロールを防止し、月送り/月戻しボタンをクリックする。
 *
 * 使用方法: <v-date-picker v-datepicker-scroll ... />
 *
 * 対応 Issue: #359
 */

/** wheel イベントハンドラー */
const handleWheel = (event: WheelEvent): void => {
  const target = event.target as HTMLElement;
  // イベント発生元が v-date-picker 内か判定
  const datePicker = target.closest(".v-date-picker");
  if (!datePicker) return;

  // ページスクロールを抑止
  event.preventDefault();
  event.stopPropagation();

  // 水平スクロール（deltaY === 0）は無視
  if (event.deltaY === 0) return;

  // スクロール方向に応じて月送り/月戻しボタンをクリック
  // deltaY > 0: 下スクロール → 次月、deltaY < 0: 上スクロール → 前月
  const testId = event.deltaY > 0 ? "next-month" : "prev-month";
  const button = datePicker.querySelector<HTMLButtonElement>(
    `[data-testid="${testId}"]`
  );
  if (button && !button.disabled) {
    button.click();
  }
};

/** v-datepicker-scroll ディレクティブ定義 */
const datepickerScrollDirective: Directive = {
  mounted(el: HTMLElement) {
    el.addEventListener("wheel", handleWheel as EventListener, {
      passive: false,
    });
  },
  unmounted(el: HTMLElement) {
    el.removeEventListener("wheel", handleWheel as EventListener);
  },
};

export default {
  install(app: App): void {
    app.directive("datepicker-scroll", datepickerScrollDirective);
  },
};
